import { useState } from 'react';
import { Check, Minus, X } from 'lucide-react';
import type { Match } from '../catalog.ts';

const ICON = { ok: Check, partial: Minus, missing: X } as const;
const COLOR = { ok: 'var(--success)', partial: 'var(--warning)', missing: 'var(--danger)' } as const;

// Score de compatibilité + détail critère par critère. `perspective` change seulement le vocabulaire.
export function MatchBadge({ match, perspective }: { match?: Match | null; perspective: 'extra' | 'resto' }) {
  const [open, setOpen] = useState(false);
  if (!match) return null;
  if (match.score === null) return perspective === 'extra' ? <span className="badge badge-neutral">Aucune exigence précisée</span> : null;

  const tone = match.blocked ? 'badge-unavailable' : match.score >= 75 ? 'badge-available' : 'badge-pending';
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <button type="button" className={`badge ${tone}`} style={{ border: 'none', cursor: 'pointer', alignSelf: 'flex-start' }} onClick={() => setOpen(!open)} aria-expanded={open}>
        {match.blocked ? (perspective === 'extra' ? 'Profil incomplet pour cette mission' : 'Exigences non remplies') : `Compatibilité ${match.score} %`}
        {match.blocked && ` · ${match.score} %`} · {open ? 'masquer' : 'détail'}
      </button>
      {open && (
        <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 4, fontSize: 12.5 }}>
          {match.reasons.map((r, i) => {
            const Icon = ICON[r.status];
            return (
              <li key={i} style={{ display: 'flex', gap: 6, alignItems: 'flex-start', color: COLOR[r.status] }}>
                <Icon size={14} style={{ marginTop: 2, flexShrink: 0 }} />
                <span style={{ color: 'var(--text)' }}>{r.label}{r.blocking && <strong style={{ color: 'var(--danger)' }}> · obligatoire</strong>}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
